import type { LongCopy } from '../copy'

export const es: LongCopy = {
  home: { title: 'Planeta ABV Develop', lead: 'Aquí viven nuestro equipo y nuestras competencias. A su alrededor giran las lunas de cada área y, más lejos, los planetas de los proyectos que hemos construido. Elige tu destino.', cta: 'Enviar un plan de vuelo' },
  team: {
    analytics: {
      name: 'Análisis de sistemas',
      tagline: 'Traducimos el negocio al lenguaje de los sistemas',
      about: 'Aquí empieza cada proyecto. Nuestros analistas entienden cómo funciona de verdad el negocio del cliente y lo convierten en requisitos, diagramas de procesos y contratos de API para que el equipo construya sin suposiciones.',
      facts: ['Primero entendemos el proceso, después escribimos código', 'Requisitos, mapas de procesos y prototipos de interfaz', 'Contratos de API acordados antes de empezar a desarrollar'],
      soon: 'Pronto aquí: noticias y descubrimientos del equipo de análisis',
    },
    ai: {
      name: 'Ingeniería de IA',
      tagline: 'Inteligencia dentro de los procesos reales',
      about: 'El equipo diseña agentes de IA, búsqueda sobre los datos de la empresa, reconocimiento de documentos y conexiones MCP con asistentes, para que la IA sirva a un proceso real y no a una demo.',
      facts: ['Agentes de IA y servidores MCP', 'Búsqueda y RAG sobre los datos de la empresa', 'Reconocimiento de documentos, escaneos y especificaciones'],
      soon: 'Pronto aquí: experimentos y noticias del equipo de IA',
    },
    development: {
      name: 'Desarrollo',
      tagline: 'Sistemas que funcionan durante años',
      about: 'Los desarrolladores backend y frontend trabajan sobre contratos acordados: revisión de código, control de versiones y una arquitectura preparada para crecer en carga y funciones.',
      facts: ['Backend y frontend en un mismo equipo', 'Revisión de código obligatoria', 'Arquitectura para alta carga'],
      soon: 'Pronto aquí: noticias y novedades técnicas de nuestros desarrolladores',
    },
    testing: {
      name: 'Testing',
      tagline: 'Encontramos los errores antes que tus clientes',
      about: 'Los ingenieros de QA prueban funciones, integraciones y regresiones, automatizan los escenarios críticos y hacen pruebas de carga antes de cada salida a producción.',
      facts: ['Pruebas funcionales, de integración y de regresión', 'Tests automáticos para los flujos críticos', 'Pruebas de carga antes del lanzamiento'],
      soon: 'Pronto aquí: noticias y retos del equipo de QA',
    },
    devops: {
      name: 'DevOps',
      tagline: 'Publicamos rápido y de forma estable',
      about: 'Compilación y despliegue automáticos en entornos de pruebas y producción, monitorización, seguridad de los entornos y escalado, para que las nuevas versiones salgan a menudo y sin sorpresas.',
      facts: ['CI/CD en todos los entornos', 'Monitorización y seguimiento de errores', 'Clústeres y balanceo de carga'],
      soon: 'Pronto aquí: noticias y trucos del equipo de DevOps',
    },
  },
  projects: { platform: 'Plataforma de distribución', grid: 'Red eléctrica digital', panel: 'Subestaciones en 10 min' },
  careers: { name: 'Espacio abierto', lead: 'Un planeta para quienes quieren construir sistemas con nosotros. Cada vacante es una misión.', mission: 'Aceptar la misión →' },
  mission: {
    title: 'Misión «De la idea al lanzamiento»',
    intro: 'Recorre el mismo camino que cada uno de nuestros proyectos: análisis → IA → desarrollo → testing → lanzamiento. Al final te espera una postal con un deseo para descargar.',
    progress: 'Etapas de la misión',
    locked: 'Esta etapa se desbloquea después del planeta',
    goTo: 'Volar allí',
    done: '¡Etapa superada!',
    continueTo: 'Siguiente etapa:',
    analytics: {
      task: 'Tarea de análisis: elige 3 tarjetas: ¿qué debe transmitir la postal?',
      cards: [
        { id: 'calm', label: 'Calma' }, { id: 'energy', label: 'Energía' }, { id: 'luck', label: 'Suerte' },
        { id: 'team', label: 'Para el equipo' }, { id: 'bold', label: 'Ideas audaces' }, { id: 'joy', label: 'Alegría' },
      ],
      pick: 'Elegidas',
      confirm: 'Aprobar requisitos',
    },
    ai: {
      task: 'La IA ha redactado deseos a partir de tus requisitos. Elige el mejor.',
      generating: 'El modelo está pensando…',
      choose: 'Elegir',
      wishes: {
        calm: ['Que tu día sea tranquilo y tus tareas, resolubles.'],
        energy: ['¡Energía para todo el día y un poco más para la noche!'],
        luck: ['Que hoy todo salga a la primera.'],
        team: ['¡Un gran día para ti y para tu equipo!'],
        bold: ['Que hoy las ideas audaces se conviertan en planes.'],
        joy: ['¡Más motivos para sonreír, empezando hoy!'],
      },
      fallback: ['¡Que tengas un gran día y tareas sencillas!'],
    },
    development: {
      task: 'Monta la postal con componentes ya preparados.',
      backgrounds: ['Espacio profundo', 'Aurora', 'Atardecer orbital'],
      planets: ['Planeta ABV', 'Gigante con anillos', 'Luna azul'],
      bg: 'Fondo',
      planet: 'Planeta',
      build: 'Compilar',
    },
    testing: {
      task: 'Encuentra 3 errores en la compilación: tócalos directamente en la postal.',
      found: 'Encontrados',
      bugs: ['una errata en el texto', 'un planeta descolocado', 'una estrella roja de más'],
      allFound: 'Todos los errores corregidos: la versión está lista para publicarse',
    },
    devops: {
      task: 'Todo está probado. ¡Vamos a lanzar!',
      countdown: 'Cuenta atrás',
      launch: 'Lanzar la versión',
      released: '¡Lanzamiento completado!',
    },
    postcard: {
      title: 'Tu postal está lista',
      nameLabel: 'Para quién es',
      namePlaceholder: 'Nombre',
      from: 'con cariño desde el sistema ABV Develop',
      download: 'Descargar postal',
      share: 'Copiar el enlace del sitio',
      copied: 'Enlace copiado',
      again: 'Jugar otra vez',
      greeting: 'Que tengas un buen día',
    },
  },
  brief: {
    title: 'Plan de vuelo',
    intro: 'Cuéntanos tu reto en cuatro pasos: la solicitud vuela hasta nuestro equipo y te respondemos.',
    steps: ['Destino', 'Carga', 'Plazos', 'Tripulación'],
    destination: '¿Qué tipo de sistema necesitas?',
    destinations: [
      { id: 'erp', label: 'ERP / CRM', hint: 'procesos, contabilidad, documentos' },
      { id: 'catalog', label: 'Catálogo y búsqueda', hint: 'portal B2B, grandes surtidos' },
      { id: 'ai', label: 'Agentes de IA', hint: 'automatización, MCP, reconocimiento' },
      { id: 'engineering', label: 'Sistema de ingeniería', hint: 'energía, configuradores, GIS' },
      { id: 'other', label: 'Otra cosa', hint: 'lo definimos juntos' },
    ],
    cargo: '¿Qué es importante en el proyecto? Puedes elegir varias',
    cargoItems: ['Automatizar procesos', 'Integración con otros sistemas', 'Alta carga', 'IA y datos', 'Evolucionar un sistema existente', 'Empezar desde cero'],
    cargoNote: 'Unas palabras sobre el reto (opcional)',
    timeline: '¿Cuándo quieres empezar?',
    timelines: ['Lo antes posible', 'En 1–3 meses', 'En unos seis meses', 'Aún lo estamos valorando'],
    crew: '¿Con quién contactamos?',
    name: 'Nombre',
    email: 'Correo de trabajo',
    message: 'Comentario',
    next: 'Siguiente',
    back: 'Atrás',
    launch: 'Enviar solicitud',
    sending: 'Enviando…',
    sent: '¡Tu solicitud está en órbita! Te responderemos por correo muy pronto.',
    error: 'No se pudo enviar. Inténtalo de nuevo o escribe a sales@abvdevelop.com.',
    summary: 'Plan de vuelo desde el sitio web',
  },
}
